import React from 'react';
import Modal from 'shared/modals/Modal';
import BaseGrid from '../../../shared/components/grids/BaseGrid/BaseGrid';

const PresetValidationModal = ({ onClose, data }) => {
  return (
    <Modal isOpen={true} title={`Preset Validation`} handleClose={onClose} containerStyle='medium'>
      <BaseGrid
        data={data}
        hideActionsCell
        columns={[
          {
            title: 'Column',
            field: 'displayName',
          },
          { title: 'Message', field: 'message' },
        ]}
      />
    </Modal>
  );
};

export default PresetValidationModal;
